<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15rem"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <main
      v-if="view === 'confirmation'"
      class="flex flex-col items-center justify-center"
    >
      <h3 class="text-2xl text-fg-default">Terminate</h3>
      <p
        style="word-break: normal"
        class="leading-loose text-xs text-center lg:w-11-12 my-4 lg:text-sm font-light"
      >
        Are you sure you want to cancel this payout? This would be terminating
        all the payout and deposit would be refunded to your holding balance.
      </p>
      <div class="flex items-center gap-x-3 mt-4 w-full px-4">
        <el-button
          class="border-primary text-primary w-full px-4 py-3.5 shadow-xs rounded-lg text-xs lg:text-base"
          @click="handleClose"
          >No, Go Back</el-button
        >
        <el-button
          @click="toggleView"
          class="bg-primary text-fg-on-accent px-4 py-3.5 shadow-xs rounded-lg w-full text-xs lg:text-base"
          >Yes, Terminate</el-button
        >
      </div>
    </main>
    <section v-else>
      <el-form
        ref="ruleFormRef"
        :rules="rules"
        :model="form"
        label-position="top"
      >
        <el-form-item label="Termination Reason" prop="reason">
          <el-input
            v-model="form.reason"
            type="textarea"
            placeholder="Give reason for termination..."
          />
        </el-form-item>
        <el-button
          @click="validateForm('ruleFormRef')"
          class="bg-primary text-fg-on-accent rounded shadow-xs px-4 py-3.5 lg:w-4/12"
          >Next</el-button
        >
      </el-form>
    </section>
  </el-dialog>
</template>
<script>
import breakpoints from '@/utils/breakpoints.js'
import { ValidateInput } from '@/utils/helpers.js'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints,
      transferReason: '',
      view: 'confirmation',
      form: {
        reason: ''
      },
      rules: {
        reason: [
          {
            required: true,
            message: 'Please enter a reason',
            trigger: ['blur', 'change']
          },
          {
            validator: ValidateInput,
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '70%' : '85%'
    }
  },
  methods: {
    toggleView () {
      this.view = 'form'
    },
    handleClose () {
      this.$emit('closeDialog')
    },
    handleTerminateBulkPayout () {
      this.$emit('handleTerminateBulkPayout', this.form.reason)
    },
    validateForm (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.handleTerminateBulkPayout()
        } else {
          this.$notify.error({
            title: 'Invalid input',
            message: 'Please enter a reason',
            position: 'top-right'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
li {
  word-break: normal;
}
.slide-fade-enter-active {
  animation: slide-fade 0.3s ease forwards;
}
.slide-fade-leave-active {
  animation: slide-fade 0.3s ease forwards alternate-reverse;
}

@media screen and (max-width: 768px) {
  >>> .el-radio__label {
    font-size: 12px;
  }
}
>>> .el-dialog {
  border-radius: 0.5rem !important;
}
>>> .el-radio__inner {
  height: 1.2rem;
  width: 1.2rem;
  border: 2px solid #bdbdbd;
}
@media screen and (min-width: 1280px) {
  >>> .el-dialog {
    margin-right: 33vw;
  }
}
@media screen and (min-width: 1680px) {
  >>> .el-dialog {
    margin-right: 34vw;
  }
}
</style>
